import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "e-forsyning-flyttemeddelelse-udflytter",
    templateUrl: "./flyttemeddelelse-udflytter.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlyttemeddelelseUdflytterComponent implements OnInit {
    @Input() public formGroup: UntypedFormGroup;
    @Input() public erAflaesningFravalgt = false;
    public maxDate: Date;

    public ngOnInit(): void {
        this.maxDate = this.beregnSenesteUdflytningsdato();
        if (!this.formGroup.get("erUdflytterMailSynlig").value) {
            this.formGroup.get("mail").disable();
        }
    }

    private beregnSenesteUdflytningsdato(): Date {
        // Hvis forsyningen ikke ønsker at en fraflytning aflæsning, skal det muligt at vælge en fremtidig udflyttedato jf. VRD
        const idag = new Date();
        const omEtAar = new Date(idag.getFullYear() + 1, idag.getMonth(), idag.getDate());
        return this.erAflaesningFravalgt ? omEtAar : idag;
    }
}
